module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"_second_opinion":"Second opinion","ipv6_second_opinion":"Perform Retest","documentation":"Documentation"},"nl":{"_second_opinion":"Second opinion","ipv6_second_opinion":"Opnieuw testen","documentation":"Documentatie"}}')
  delete Component.options._Ctor
}
